<div class='styled-checkbox'>
  <input type="checkbox" [id]="inputName" [attr.name]="inputName" [(ngModel)]="checkboxModel" (change)="handleChange()"/>
  <label [for]="inputName">{{labelText}}</label>
</div>
